import { render, staticRenderFns } from "./aed-publicHolidays.vue?vue&type=template&id=a612fc08&"
import script from "./aed-publicHolidays.vue?vue&type=script&lang=js&"
export * from "./aed-publicHolidays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports